export default __webpack_public_path__ + "assets/images/1.88e7c6.png";